import { render, staticRenderFns } from "./ScaniaGauges.vue?vue&type=template&id=324fa395&"
import script from "./ScaniaGauges.vue?vue&type=script&lang=js&"
export * from "./ScaniaGauges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports